const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      // Главная
      { name: 'Index', path: '/', component: () => import('pages/Index.vue') },

      // Мои лиды
      {
        name: 'DealDetails',
        path: '/deal/:id',
        component: () => import('pages/Deals/DealDetails.vue')
      },

      {
        name: 'Deals',
        path: '/deals',
        component: () => import('pages/Deals/Deals.vue')
      },

      // Мои рекламации
      {
        name: 'Complaints',
        path: '/complaints',
        component: () => import('../pages/Complaints/Complaints')
      },
      {
        name: 'ComplaintDetails',
        path: '/complaint/:id',
        component: () => import('../pages/Complaints/ComplaintDetails')
      },
      {
        name: 'NewComplaint',
        path: '/new-complaint',
        component: () => import('../pages/Complaints/NewComplaint')
      },

      // Мои просчеты
      {
        name: 'Calculations',
        path: '/calculations',
        component: () => import('../pages/Сalculations/Calculations')
      },
      {
        name: 'CalculationDetails',
        path: '/calculation/:id',
        component: () => import('../pages/Сalculations/CalculationDetails')
      },
      {
        name: 'NewCalculation',
        path: '/new-calculation',
        component: () => import('../pages/Сalculations/NewCalculation.vue')
      },

      // Профиль, логин
      {
        name: 'SignIn',
        path: '/sign-in',
        component: () => import('pages/SignIn.vue'),
        meta: {
          category: 'login'
        }
      },
      {
        name: 'Profile',
        path: '/profile',
        component: () => import('pages/Profile.vue')
      },

      {
        name: 'ChatDetails',
        path: '/chat/:id',
        component: () => import('../pages/Chat/ChatDetails.vue')
      },
      {
        name: 'ChatsList',
        path: '/chats',
        component: () => import('../pages/Chat/ChatsList.vue')
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    name: 'Error404',
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
